module.exports = __webpack_public_path__ + "static/media/linkedin.f386a917.svg";